import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TrainingsTable } from '../../common/types/types';

interface TrainingsState {
  reachedTrainings: TrainingsTable[];
}

const initialState: TrainingsState = {
  reachedTrainings: [],
};

const TrainingsSlice = createSlice({
  name: 'Trainings',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setReachedTrainings: (state, action: PayloadAction<TrainingsTable[]>) => {
      return { ...state, reachedTrainings: action.payload };
    },
  },
});

export const { reset, setReachedTrainings } = TrainingsSlice.actions;
export default TrainingsSlice.reducer;
